import React from "react";
import { useCountdown } from "./UseCountdown";
import styled from "@emotion/styled";

import withTranslator from "../Translator/withTranslation";

const CountdownWrapper = styled.div `
    font-size:0.6em;
    background:#f00;
    color:#fff;
    border-radius:3px;
    padding:0px 5px;
    margin-left:10px;
    @media (max-width: 499px) {
    }
    @media (min-width: 500px) and (max-width: 768px) {
    }
`;
const CountDownItem = styled.div `
    font-size:1em;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    width: auto;
    padding:5px 2px;
    margin: 0px;
    @media (max-width: 499px) {
        font-size:1em;
        line-height: 1.2em;
        width:auto;
    }
`;
const CountDownItemLabel = styled.span `
    font-size: 0.5em;
    font-weight: 600;
    text-transform: uppercase;
    @media (max-width: 499px) {
        font-size: 0.5em;
        margin: 0px;
    }
`;

 const CountdownSearchResultComponent = (props) => {
    const timer = useCountdown(props.data.discountEndsAt, props.data.discountEndsAtFormat);
    return ( 
        props.data.discountEndsAt && <CountdownWrapper >
            {timer.days !== '' && (
                    <CountDownItem>
                        {timer.days}
                        <CountDownItemLabel>{props.t('days')}</CountDownItemLabel>
                    </CountDownItem>
                )}
             {timer.hours !== '' && (
                    <CountDownItem>
                        {timer.hours}
                        <CountDownItemLabel>{props.t('hours')}</CountDownItemLabel>
                    </CountDownItem>
                )}
             {timer.minutes !== '' && (
                    <CountDownItem>
                        {timer.minutes}
                        <CountDownItemLabel>{props.t('minutes')}</CountDownItemLabel>
                    </CountDownItem>
                )}
             {timer.seconds !== '' && (
                    <CountDownItem>
                        {timer.seconds}
                        <CountDownItemLabel>{props.t('seconds')}</CountDownItemLabel>
                    </CountDownItem>
                )}
        </CountdownWrapper>
    );
}

export const CountdownSearchResult = withTranslator(CountdownSearchResultComponent);